import { homeApi } from "../../home/api/home.api";
import { gameApi } from "../api/game.api";
import { casinoApi } from "../api/casino.api";
import { toastService as toast } from "../../../components/ui/toast/toast.service";
import { DeviceType } from "../../../models/constants/deviceType";
import localization from "../../../config/localization";
import { ProviderNames } from "../models/constants/providerNames";
import { localStorageService } from "../../../services";
import { SHOW_MAINTENANCE_EVENT } from "../../../components/ui/modals/GameMaintenanceModal";
import { launchGapGame } from "./gap.service";
import { QtechFreeSpin } from "./qtech.service";
import { BannerImageResponse } from "../../home/models";
import { GameCodeConsts } from "../models/constants/gameCodeConsts";
import { GameListResponse, GameDataList, GameCategoryListResponse, GameProviderResponse, GameSupplierList } from "../models/responses/index";
import { GameListRequest, CheckGameAvailabilityRequest, RetrieveTrendingGamesRequest } from "../models/requests/index";
import { UnifiedResponse } from "../../../models/Response/unifiedResponse";
import errorModal from "../../../services/errorModal.service";
import { ExchangeWindowClose } from "../../../assets/js/common";
const PAGE_SIZE = 20;

/* Select Vertical */

export async function SelectVertical() {
  const verticalsResponse = await homeApi.fetchActiveVerticals();

  if (!verticalsResponse.isSuccess) {
    window.location.href = "/";
    return;
  }
  const details = verticalsResponse.data?.details ?? [];
}

/* Banner Retrieve */
export async function setBannerImage(
  setBannerImageResponse: (value: BannerImageResponse | null) => void,
  languageForBanner: string = "English",
  setSegmentations: (value: string[]) => void, // required, no ?
): Promise<void> {
  const screenWidth = window.innerWidth;

  const result = await homeApi.retrieveBanners({
    bannerType: "Casino HomePage",
    language: languageForBanner === "hi-IN" ? "Hindi" : "English",
    deviceType: screenWidth < 768 ? DeviceType.Mobile : DeviceType.Web,
  });

  if (result.isSuccess) {
    await retrieveUserBySegmentation(setSegmentations);
    setBannerImageResponse(result.data ?? null);
  } else {
    errorModal.showErrorModal(result.statusCode, result.message);
    setBannerImageResponse(null);
  }
}

/* Retrieve user by segmentation */
export async function retrieveUserBySegmentation(
  setSegmentations: (value: string[]) => void,
): Promise<void> {
  const result = await casinoApi.retrieveSegmentationByUser();

  if (result.statusCode === 200 && result.data?.details) {
    const segmentations = result.data.details.map(
      (item) => item.segmentationids,
    );
    setSegmentations(segmentations);
  } else {
    errorModal.showErrorModal(result.statusCode, result.message);

  }
}

/* Provider Retrieve */
export async function gameProvider(
  setProviderNames: (value: GameProviderResponse | null) => void,
) {
  const providerResponse = await gameApi.fetchGameProviders();
  if (!providerResponse.isSuccess) {
    window.location.href = "/";
    return;
  }
  setProviderNames(providerResponse.data);
}

/* Load Game Category */
export async function loadGameCategory(): Promise<{
  gameCategoryListResponse: GameCategoryListResponse | null;
  allCategoryId: string | undefined;
}> {
  let gameCategoryListResponse: GameCategoryListResponse | null = null;
  let allCategoryId: string | undefined;

  const result = await casinoApi.loadGameCategory();

  if (result.isSuccess && result.data) {
    gameCategoryListResponse = result.data;

    if (gameCategoryListResponse.gameCategoryList?.length > 0) {
      const allCategory = gameCategoryListResponse.gameCategoryList.find(
        (category) => category.name.toLowerCase() === "all",
      );
      allCategoryId = allCategory?.id;
    }
  } else {
    errorModal.showErrorModal(result.statusCode, result.message);
  }

  return { gameCategoryListResponse, allCategoryId };
}

/* Load Game Data */
export async function loadGameData(
  searchParam: string | null,
  pageNumber: number,
  existingGameList: GameDataList[] | null,
  options: {
    gameCategoryId?: string;
    gameSupplierName?: string;
    isFavouriteGames: boolean;
    pageSize?: number;
  },
): Promise<{
  gameListResponse: GameListResponse;
  totalCount: number;
  isLoad: boolean;
}> {
  const mobile = window.innerWidth < 768;
  const platformCsv = mobile ? DeviceType.Mobile : DeviceType.Web;
  const request: GameListRequest = {
    pageNo: pageNumber,
    pageSize: options.pageSize ?? PAGE_SIZE,
    searchBy: searchParam ? searchParam.trim() : null,
    platformCsv,
    gameCategoryId: options.gameCategoryId ?? null,
    gameSupplierName: options.gameSupplierName ?? null,
    isFavouriteGames: options.isFavouriteGames,
  };

  const result = await casinoApi.loadGameList(request);

  let gameListResponse: GameListResponse = { gameList: existingGameList ?? [] };
  if (result.isSuccess && result.data?.gameList?.length) {
    const response = result.data;
    if (!existingGameList?.length) {
      gameListResponse = response;
    } else {
      gameListResponse = {
        gameList: [...existingGameList, ...response.gameList],
      };
    }
  } else if (!result.isSuccess) {
    errorModal.showErrorModal(result.statusCode, result.message);
  }
  let totalCount = 0;
  let isLoad = false;
  if (gameListResponse.gameList.length > 0) {
    totalCount = gameListResponse.gameList[0].total ?? 0;
  } else {
    totalCount = 0;
    isLoad = true;
  }
  return { gameListResponse, totalCount, isLoad };
}

/* Load Supplier */
export async function loadSupplier(categoryId: string | null = null) {
  const result = await casinoApi.retrieveSupplierList(categoryId);

  if (result.isSuccess && result.data?.details) {
    return result.data.details;
  }

  else if (!result.isSuccess) {
    errorModal.showErrorModal(result.statusCode, result.message);
  }
  return [];
}

/* Load Game Data Category Wise */
export async function loadGameDataCategoryWise(
  categoryId: string | null,
  isFavourite: boolean,
  options: {
    setGameSupplierList: (value: GameSupplierList[]) => void;
    setGameCategoryId: (value: string | null) => void;
    setPageNumber: (value: number) => void;
    setGameListResponse: (value: { gameList: GameDataList[] }) => void;
    loadGameData: (searchParam: string) => Promise<void>;
    searchParam: string;
    setCasinoError: (message: string) => void;
  },
): Promise<void> {
  let isFetchResult = false;
  if (isFavourite) {
    isFetchResult = true;
  } else {
    const request: CheckGameAvailabilityRequest = {
      flag: "GameCategory",
      gameId: categoryId ?? "",
    };
    const result = await gameApi.checkGameAvailability(request);
    if (result.isSuccess && result.data?.messagetype === false) {
      isFetchResult = false;
      options.setCasinoError(result.data.message ?? "Something went wrong");
      return;
    } else {
      isFetchResult = true;
      await casinoApi.retrieveSupplierList(categoryId).then((res) => {
        if (res.data?.details) options.setGameSupplierList(res.data.details);
      });
    }
  }
  if (isFetchResult) {
    options.setGameCategoryId(categoryId);
    const menuId = isFavourite ? "favouritegames" : (categoryId ?? "");
    // highlightmenu code
    options.setPageNumber(0);
    options.setGameListResponse({ gameList: [] });
    await options.loadGameData(options.searchParam);
  }
}

/* Update Favorite Games */
export async function updateFavouriteGameStatus(
  gameId: string,
  isFavourite: boolean,
  options: {
    setPageNumber: (value: number) => void;
    setGameListResponse: (value: { gameList: GameDataList[] }) => void;
    loadGameData: () => Promise<void>;
  },
): Promise<void> {
  const result = await casinoApi.updateFavouriteGame({
    gameId,
    isFavourite,
  });

  if (result.isSuccess) {
    if (isFavourite) {
      toast.success(localization.game_added_favourite_list);
    } else {
      toast.success(localization.game_removed_favourite_list);
    }
    options.setPageNumber(0);
    options.setGameListResponse({ gameList: [] });
    await options.loadGameData();
  } else {
    errorModal.showErrorModal(result.statusCode, result.message);
  }
}

export async function updateFavouriteGame(gameId: string, isFavourite: boolean) {
  const result = await casinoApi.updateFavouriteGame({
    gameId,
    isFavourite,
  });

  if (result.isSuccess) {
    if (isFavourite) {
      toast.success(localization.game_added_favourite_list);
    } else {
      toast.success(localization.game_removed_favourite_list);
    }
  }
  else {
    errorModal.showErrorModal(result.statusCode, result.message);
  }
}

/* Game Login */
export async function gameLogin(
  gameUrl: string,
  gameProviderName: string,
  supplierGameCode: string,
  options: {
    gameId: string;
    gameSupplierId: string;
    gameSupplierName: string;
    searchParam: string;
    setCasinoError: (message: string) => void;
  },
  accessModeSource: string,
): Promise<string | null> {
  /* check Game Availibility */
  const result = await gameApi.checkGameAvailability({
    flag: "Game",
    gameId: options.gameId,
  });

  if (result.isSuccess && result.data && result.data.messagetype === false) {
    options.setCasinoError(result.data.message ?? "Something went wrong");
    return null;
  }

  const token = localStorage.getItem("token");

  if (token) {

    /* Transfer Fund From Exchange */
    await transferFundFromExchange();

    if (!gameUrl) {
      await loadGameData(options?.searchParam ?? null, 0, null, {
        gameCategoryId: undefined,
        gameSupplierName: undefined,
        isFavouriteGames: false,
      });
      return null;
    }
    if (gameProviderName?.trim()) {
      // select provider
      const gameProvidersResponse = await gameApi.fetchGameProviders();
      if (!gameProvidersResponse.isSuccess) {
        window.location.href = "/";
        return null;
      }
      const provider = gameProvidersResponse.data?.details?.find(
        (f) => f.name === gameProviderName,
      );
      const providerId = provider?.id;

      // select vertical
      const verticalsResponse = await homeApi.fetchActiveVerticals();
      if (!verticalsResponse.isSuccess) {
        window.location.href = "/";
        return null;
      }
      const casinoVertical = verticalsResponse.data?.details.find(
        (v) => v.name === "Casino",
      );

      const verticalId = casinoVertical?.id;

      const maintenanceResult = await gameApi.checkGameMaintenance({
        verticalId,
        providerId,
        subProviderId: options.gameSupplierId,
      });

      if (
        maintenanceResult.isSuccess &&
        maintenanceResult.data?.message?.trim() &&
        maintenanceResult.data?.fromdate &&
        maintenanceResult.data?.todate
      ) {
        window.dispatchEvent(
          new CustomEvent(SHOW_MAINTENANCE_EVENT, {
            detail: {
              message: maintenanceResult.data.message,
              toDate: maintenanceResult.data.todate,
            },
          }),
        );
        return null;
      }
      if (gameProviderName.toLowerCase() === GameCodeConsts.Qtech) {
        const userId = localStorageService.getItem<string>("providerUserId") ?? "null";
        const launchUrl = await QtechFreeSpin(
          userId,
          options.gameId,
          supplierGameCode,
          accessModeSource,
        );
        return launchUrl;
      } else if (
        gameProviderName.toLowerCase() === GameCodeConsts.Gap ||
        gameProviderName.toLowerCase() === GameCodeConsts.DC ||
        gameProviderName.toLowerCase() === GameCodeConsts.AWC
      ) {
        const launchUrl = await launchGapGame(
          gameProviderName,
          supplierGameCode,
          accessModeSource,
        );
        return launchUrl;
      } else {
        localStorageService.setItem("gameUrl", gameUrl);
        return gameUrl;
      }
    } else {
      localStorageService.setItem("gameUrl", gameUrl);
      return gameUrl;
    }
  } else {
    window.location.href = "/login";
    return null;
  }
}

async function transferFundFromExchange() {
  const balanceResponse = await homeApi.fetchUserBalance();
  if (balanceResponse.isSuccess) {
    if (
      balanceResponse.data?.is9WOn ||
      (balanceResponse.data?.exchangeBalance &&
        balanceResponse.data?.exchangeBalance > 0)
    ) {
      const transferFund = await gameApi.transferFundFromExchange();
      if (!transferFund.isSuccess) {
        errorModal.showErrorModal(transferFund.statusCode, transferFund.message, false);
      }
      else {
        await ExchangeWindowClose();
      }
    }
  }
}

/* Load Game Directly*/
export async function loadGameDirectly(
  gamePath: string,
  options: {
    setCasinoError: (message: string) => void;
  },
  accessModeSource: string,
): Promise<string | null> {
  const token = localStorageService.getItem<string>("token");
  if (token) {
    const usersVerticalResponse = await homeApi.fetchUserVerticals();
    if (usersVerticalResponse.isSuccess) {
      const excluded = usersVerticalResponse.data?.verticalsCsv ?? "";

      if (excluded.toLowerCase().includes("casino")) {
        window.location.href = "/";
        return null;
      }
    }
    else {
      errorModal.showErrorModal(usersVerticalResponse.statusCode, usersVerticalResponse.message, false);
    }

    const segments = gamePath.split("/").filter(Boolean);
    if (segments.length < 3) {
      toast.error(localization.page_not_found);
      window.location.href = "/casino";
      return null;
    }

    const supplierName = segments[0].replace(/-/g, " ");
    const providerName = ProviderNames[parseInt(segments[1])];
    const gameCode = segments[2];

    const baseUri = window.location.origin;
    const gameUrl = `&home=${encodeURIComponent(baseUri)}&exit_url=${encodeURIComponent(baseUri)}`;
    return await gameLoginDirectly(
      gameUrl,
      providerName,
      supplierName,
      gameCode,
      accessModeSource,
      options,
    );
  } else {
    localStorageService.setItem("gamePath", gamePath);
    window.location.href = "/login";
    return null;
  }
}

/* Game Login Directly*/

async function gameLoginDirectly(
  gameUrl: string,
  gameProviderName: string,
  gameSupplierName: string,
  gameCode: string,
  accessModeSource: string,
  options: {
    setCasinoError: (message: string) => void;
  },
): Promise<string | null> {
  try {
    const token = localStorageService.getItem<string>("token");
    if (token) {
      await transferFundFromExchange();
      const gameDetailsResponse = await casinoApi.getGameDetails({
        GameProvider: gameProviderName,
        GameSupplier: gameSupplierName,
        GameCode: gameCode,
        UserId: localStorageService.getItem<string>("userId")!,
      });
      if (gameDetailsResponse.statusCode === 422) {
        return null;
      } else if (gameDetailsResponse.statusCode === 404) {
        errorModal.showErrorModal(gameDetailsResponse.statusCode, gameDetailsResponse.message);
        return null;
      } else if (gameDetailsResponse.isSuccess) {
        if (gameDetailsResponse) {
          const verticalAndProviderIds =
            await getVerticalAndProviderId(gameProviderName);
          if (!verticalAndProviderIds) return null;

          const maintenanceResult = await gameApi.checkGameMaintenance({
            verticalId: verticalAndProviderIds.verticalId,
            providerId: verticalAndProviderIds.providerId,
            subProviderId: gameDetailsResponse.data?.gameSupplierId,
          });

          if (
            maintenanceResult.isSuccess &&
            maintenanceResult.data?.message?.trim() &&
            maintenanceResult.data?.fromdate &&
            maintenanceResult.data?.todate
          ) {
            window.dispatchEvent(
              new CustomEvent(SHOW_MAINTENANCE_EVENT, {
                detail: {
                  message: maintenanceResult.data.message,
                  toDate: maintenanceResult.data.todate,
                },
              }),
            );
            return null;
          }

          if (gameProviderName.toLowerCase() === GameCodeConsts.Qtech) {
            const userId = localStorageService.getItem<string>("providerUserId") ?? "null";
            const launchUrl = await QtechFreeSpin(
              userId,
              gameDetailsResponse.data?.id!,
              gameDetailsResponse.data?.code!,
              accessModeSource,
            );
            return launchUrl;
          } else if (
            gameProviderName.toLowerCase() === GameCodeConsts.Gap ||
            gameProviderName.toLowerCase() === GameCodeConsts.DC ||
            gameProviderName.toLowerCase() === GameCodeConsts.AWC
          ) {
            const subProviderName =
              gameProviderName.toLowerCase() === GameCodeConsts.DC ||
                gameProviderName.toLowerCase() === GameCodeConsts.AWC
                ? gameProviderName
                : gameDetailsResponse.data!.supplierName;

            const launchUrl = await launchGapGame(
              subProviderName,
              gameDetailsResponse.data?.code!,
              accessModeSource,
            );
            return launchUrl;
          } else {
            localStorageService.setItem("gameUrl", gameUrl);
            return gameUrl;
          }
        } else {
          await ReloadCasinoPage();
          return null;
        }
      } else {
        // 400 popup
        await ReloadCasinoPage();
        return null;
      }
    } else {
      window.location.href = "/login";
      return null;
    }
  } catch {
    await ReloadCasinoPage();
    return null;
  }
}

async function ReloadCasinoPage() {
  window.location.href = "/casino";
}

async function getVerticalAndProviderId(gameProviderName: string): Promise<{
  verticalId: string | undefined;
  providerId: string | undefined;
} | null> {
  const gameProvidersResponse = await gameApi.fetchGameProviders();
  if (!gameProvidersResponse.isSuccess) {
    window.location.href = "/";
    return null;
  }
  const provider = gameProvidersResponse.data?.details?.find(
    (f) => f.name === gameProviderName,
  );
  const providerId = provider?.id;

  const verticalsResponse = await homeApi.fetchActiveVerticals();
  if (!verticalsResponse.isSuccess) {
    window.location.href = "/";
    return null;
  }
  const casinoVertical = verticalsResponse.data?.details.find(
    (v) => v.name === "Casino",
  );

  const verticalId = casinoVertical?.id;

  return { verticalId, providerId };
}

export async function checkScheduleMaintenance(): Promise<boolean> {
  const verticalsResponse = await homeApi.fetchActiveVerticals();
  if (!verticalsResponse.isSuccess) return false;

  const casinoVertical = verticalsResponse.data?.details.find(
    (v) => v.name === "Casino",
  );
  if (!casinoVertical) return false;

  const maintenanceResponse = await gameApi.checkGameMaintenance({
    verticalId: casinoVertical.id,
  });

  if (!maintenanceResponse.isSuccess) {
    toast.error(maintenanceResponse.message || "Failed to check maintenance.");
    return true;
  }

  if (
    maintenanceResponse.data?.message &&
    maintenanceResponse.data?.fromdate &&
    maintenanceResponse.data?.todate
  ) {
    window.dispatchEvent(
      new CustomEvent(SHOW_MAINTENANCE_EVENT, {
        detail: {
          message: maintenanceResponse.data.message,
          toDate: maintenanceResponse.data.todate,
        },
      }),
    );
    return true;
  }

  return false;
}

export async function fetchRecentlyPlayedGames(): Promise<UnifiedResponse<GameListResponse>> {
  return await casinoApi.fetchRecentlyPlayedGames();
}

export async function fetchTrendingGames(request: RetrieveTrendingGamesRequest): Promise<UnifiedResponse<GameListResponse>> {
  return await casinoApi.fetchTrendingGames(request);
}

